import { render } from "./index.vue?vue&type=template&id=a63dda7a&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Promotors/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a63dda7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a63dda7a', __exports__)) {
    api.reload('a63dda7a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a63dda7a&ts=true", () => {
    api.rerender('a63dda7a', render)
  })

}


export default __exports__